import { Loading } from "../../components"

export const LoadingPage = () => {
    return (
        <div className='page'>
            <Loading size={60 }/>
        </div>
    )
}